import type { Environment } from './environment.model';

export const environment: Environment = {
  apiBaseUrl: '',
  gainsightPxKey: 'AP-5PAYV3N1FZOG-2-4',
  aura: {
    apiBaseUrl: 'https://api.int.ai-assistant.unityaiot.com',
  },
  showLibrary: true,
};
